import { useState } from 'react'
import { Box, Typography, Grid, Divider, Tooltip, IconButton } from '@mui/material'

import { Button } from '@/@core/components/mui/Button'
import { FilterButton } from '../common'
import { TableLimit } from '@/@core/components/mui/TableLimit'
import { useRouteQuery, useTranslator } from '@/hooks'
import { SearchInput } from '../common/SearchInput'
import CompanyStatusSelection from '../selection/CompanyStatusSelection'
import InputDateRangerField from '../common/input/InputDateRangerField'

interface EmployerTableFilterProps {
  onSearch?: (value: string) => void
  onAddEmployee?: () => void
  onOpenLogs?: () => void
}

export const EmployerTableFilter = ({ onAddEmployee, onOpenLogs }: EmployerTableFilterProps) => {
  const { __ } = useTranslator()
  const { updateQuery, searchQuery } = useRouteQuery()
  const [filter, setFilter] = useState(true)
  // const navigate = useNavigate()

  return (
    <Box
      sx={{
        display: 'flex',
        padding: '20px',
        gap: 4,
        flexDirection: 'column'
      }}
    >
      {filter && (
        <>
          <Box className='mb-3'>
            <Typography variant='h6' className='mb-3'>
              {__('Filters')}
            </Typography>
            <Grid container spacing={2}>
              <Grid size={4}>
                <InputDateRangerField
                  value={
                    searchQuery.get('contract_start_date')
                      ? [
                          searchQuery.get('contract_start_date') as string,
                          searchQuery.get('contract_end_date') as string
                        ]
                      : []
                  }
                  onChange={created_at => {
                    if (created_at) {
                      updateQuery({ contract_start_date: created_at[0], contract_end_date: created_at[1], page: 1 })
                    } else {
                      updateQuery({ contract_start_date: undefined, contract_end_date: undefined, page: 1 })
                    }
                  }}
                />
              </Grid>
              <Grid size={4}>
                <CompanyStatusSelection
                  value={searchQuery.get('status') || ''}
                  onSelect={status => {
                    updateQuery({ status, page: 1 })
                  }}
                />
              </Grid>
            </Grid>
          </Box>
          <Divider />
        </>
      )}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
        <TableLimit />

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <SearchInput
            placeholder={__('Search Employer')}
            onSearch={value => {
              updateQuery({ keywords: value })
            }}
            initialValue={searchQuery.get('keywords') || ''}
          />

          <FilterButton filter={filter} onFilter={() => setFilter(!filter)} />

          <Button
            variant='contained'
            onClick={onAddEmployee}
            startIcon={<i className='tabler-plus' />}
            sx={{ height: 38 }}
          >
            {__('Add Employer')}
          </Button>

          <Tooltip title='History'>
            <IconButton
              size='small'
              onClick={onOpenLogs}
              sx={{
                width: 40,
                height: 40,
                backgroundColor: '#f5f5f5',
                '&:hover': {
                  backgroundColor: '#e0e0e0'
                }
              }}
            >
              <i className='tabler-history' style={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        </Box>
      </Box>
    </Box>
  )
}
